import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
interface StrategyMapHeaderMetricBlockProps {
  item: {
    title: string;
    date: string;
    value: string;
    icon: IconProp;
  };
  color?: string;
  compact?: boolean;
}
const StrategyMapHeaderMetricBlock: React.FC<
  StrategyMapHeaderMetricBlockProps
> = ({ item, color = 'text-sky-600', compact = false }) => {
  return (
    <div className={`bg-level-1 rounded-lg flex flex-col justify-center items-start overflow-hidden ${compact ? 'px-3 py-2 gap-1' : 'min-w-48 px-6 py-4 gap-2'}`}>
      <div className="self-stretch inline-flex justify-between items-center">
        <div className="rounded-lg flex justify-start items-center gap-1 overflow-hidden">
          <div className={`flex items-center justify-center flex-shrink-0 ${compact ? 'w-3 h-3' : 'w-4 h-4'}`}>
            <Icon icon={item.icon} className={`${color} ${compact ? 'w-3 h-3' : 'w-4 h-4'}`} />
          </div>
          <div
            className={`text-center justify-start ${color} font-bold font-['Inter'] leading-5 ${compact ? 'text-xs' : 'text-sm'}`}
          >
            {item.title}
          </div>
        </div>
        {item.date && (
          <div className="justify-start text-tertiary text-sm font-normal font-['Inter'] leading-5 line-clamp-1">
            {item.date}
          </div>
        )}
      </div>
      <div className={`justify-start text-primary font-extrabold font-['Inter'] ${compact ? 'text-lg leading-6' : 'text-2xl leading-8'}`}>
        {item.value}
      </div>
    </div>
  );
};

export default StrategyMapHeaderMetricBlock;
